import { isFuture, isToday, subDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';

import UI from '../../common/UI';
import useLocale from '../../common/useLocale';

interface PaymentReminderInfoProps {
  dueDates: string[];
}

const PaymentReminderInfo = ({ dueDates }: PaymentReminderInfoProps) => {
  const { t } = useTranslation();
  const { parseDate, formatDate } = useLocale();

  const dates = uniq(dueDates).map((dueDate) => parseDate(dueDate, { format: 'internal_date' }));

  const reminders = sortBy(
    dates.reduce((reminders, date) => [
      ...reminders,
      subDays(date, 30),
      subDays(date, 14),
      subDays(date, 1),
    ], [] as Date[]).filter((date) => isToday(date) || isFuture(date)),
    (reminder) => reminder.getTime(),
  );

  return (
    <UI.Info>
      {reminders.length > 0 && (
        <>
          <UI.Strong>{t('reminders_will_be_sent_on')}</UI.Strong>
          <UI.UL>
            {reminders.map((date, index) => (
              <UI.LI key={index}>
                {formatDate(date, { format: 'display_date' })}
              </UI.LI>
            ))}
          </UI.UL>
        </>
      )}
      {reminders.length === 0 && (
        <UI.Strong>{t('no_reminders_will_be_sent')}</UI.Strong>
      )}
    </UI.Info>
  );
};

export default PaymentReminderInfo;
